import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import { SCREEN_ID_UTILITY_PROFIT_PARTNER_USER_ACTIVATION } from 'client/constants/screenIds';

import log from 'client/lib/log';
import AuthActions from 'client/actions/Auth';
import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

@withTransitionHook
@withScreenId(SCREEN_ID_UTILITY_PROFIT_PARTNER_USER_ACTIVATION)
@withScrollToTop
@branch({
  currentUserRoles: ['currentUser', 'roles'],
  currentUtilityUser: ['utilityUser'],
})
class UtilityProfitActivatePartnerUserRedirectPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Utility Profit | Partner User Redirect',
  });

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { dispatch } = this.props;

    const locationQuery = queryString.parse(location.search);
    const redirectUrl =
      '/utility-profit/reset-password?activate=true' +
      (locationQuery.phone ? `&phone=${locationQuery.phone}` : '');
    dispatch(AuthActions.logout)
      .then(() => {
        global.location.href = redirectUrl;
      })
      .catch((error) => log.error(error));
  }

  render() {
    return (
      <div className="page-logout">
        <div className="loginContainer">
          <div className="loading-ellipses" />
        </div>
      </div>
    );
  }
}

UtilityProfitActivatePartnerUserRedirectPage.displayName =
  'UtilityProfitActivatePartnerUserRedirectPage';

export default UtilityProfitActivatePartnerUserRedirectPage;
